var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { BsCheckCircleFill } from 'react-icons/bs';
import { FcGoogle } from 'react-icons/fc';
import styled from 'styled-components';
import { useFlashMessage } from '@app/components/obj.flash-message';
import { axiosClient } from '@app/configure-app';
import { Button, FlashMessageEnum } from '@atomic';
import { Modal } from '@atomic/obj.modal/modal.component';
import { QuickChecklistTitle } from './styles';
export var GoogleBusinessRedirectModal = function (_a) {
    var open = _a.open, onClose = _a.onClose, urlGoogleBusiness = _a.urlGoogleBusiness, npsId = _a.npsId, _b = _a.comentario, comentario = _b === void 0 ? '' : _b;
    var showFlashMessage = useFlashMessage()[0];
    var _c = React.useState(false), isCopied = _c[0], setIsCopied = _c[1];
    var goToGoogleBusiness = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axiosClient.put("nps/" + npsId, {
                            acessoGoogleMeuNegocio: true,
                            urlGoogleMeuNegocio: urlGoogleBusiness,
                        })];
                case 1:
                    _a.sent();
                    window.location.href = urlGoogleBusiness;
                    onClose();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error('Erro ao redirecionar:', error_1);
                    alert('Falha ao redirecionar para o Google.');
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var copyToClipboard = function () { return __awaiter(void 0, void 0, void 0, function () {
        var textArea;
        return __generator(this, function (_a) {
            try {
                textArea = document.createElement('textarea');
                textArea.value = comentario;
                textArea.style.position = 'fixed';
                textArea.style.opacity = '0';
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                document.execCommand('copy');
                document.body.removeChild(textArea);
                setIsCopied(true);
                showFlashMessage(FlashMessageEnum.success, 'Avaliação copiada para área de transferência.');
            }
            catch (err) {
                console.error('Erro ao copiar: ', err);
                showFlashMessage(FlashMessageEnum.alert, 'Erro ao copiar o comentário: ' + err);
            }
            return [2 /*return*/];
        });
    }); };
    var copyToClipboard2 = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, navigator.clipboard.writeText(comentario)];
                case 1:
                    _a.sent();
                    setIsCopied(true);
                    showFlashMessage(FlashMessageEnum.success, 'Avaliação copiada para área de transferência.');
                    return [3 /*break*/, 3];
                case 2:
                    err_1 = _a.sent();
                    showFlashMessage(FlashMessageEnum.alert, 'Erro ao copiar o comentário: ' + err_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleClose = function () {
        onClose();
        setIsCopied(false);
    };
    return (React.createElement(Modal, { opened: open, closeOnOutsideClick: false, onClose: handleClose },
        React.createElement(ModalContainer, null,
            React.createElement("br", null),
            React.createElement(BsCheckCircleFill, { color: "#34a853", size: '50px' }),
            React.createElement(QuickChecklistTitle, null,
                React.createElement("h2", null, "Levar pro Google!")),
            React.createElement(ModalText, null, isCopied ? 'Agora é só colar e concluir lá!' : 'Toque abaixo para copiar e publicar.'),
            !isCopied ? (React.createElement(React.Fragment, null,
                React.createElement(GoogleButton, { type: "button", variant: "primary", expanded: true, onClick: copyToClipboard },
                    React.createElement(ButtonText, null,
                        React.createElement(FcGoogle, { size: '25px' }),
                        React.createElement("b", null, "Copiar"),
                        "\u00A0e Avaliar no ",
                        React.createElement(GoogleName, null, "\u00A0Google"))),
                React.createElement(CopiedText, { style: { visibility: 'hidden' } },
                    React.createElement(BsCheckCircleFill, { color: "#34a853", style: { marginRight: '5px' } }),
                    "Copiado!"))) : (React.createElement(React.Fragment, null,
                React.createElement(GoogleButton, { type: "button", variant: "primary", expanded: true, onClick: goToGoogleBusiness },
                    React.createElement(ButtonText, null,
                        React.createElement(FcGoogle, { size: '25px' }),
                        "Colar e Avaliar no ",
                        React.createElement(GoogleName, null, "\u00A0Google"))),
                React.createElement(CopiedText, null,
                    React.createElement(BsCheckCircleFill, { color: "#34a853", style: { marginRight: '5px' } }),
                    "Copiado!"))))));
};
var ModalContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: #fff;\n  text-align: center;\n  max-width: 300px;\n  margin: 0 auto;\n"], ["\n  background: #fff;\n  text-align: center;\n  max-width: 300px;\n  margin: 0 auto;\n"])));
var ModalText = styled.p(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 18px;\n  margin: 10px 0;\n"], ["\n  font-size: 18px;\n  margin: 10px 0;\n"])));
var ButtonText = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var GoogleButton = styled(Button)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background: linear-gradient(90deg, #4285f4, #34a853);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  width: 100%;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 50px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.9;\n    color: white !important;\n  }\n\n  &:active {\n    opacity: 0.8;\n  }\n\n  &:disabled {\n    background: #a0c3ff;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n"], ["\n  background: linear-gradient(90deg, #4285f4, #34a853);\n  color: white;\n  border: none;\n  border-radius: 10px;\n  width: 100%;\n  font-size: 16px;\n  cursor: pointer;\n  margin-top: 50px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.2s ease;\n\n  &:hover {\n    opacity: 0.9;\n    color: white !important;\n  }\n\n  &:active {\n    opacity: 0.8;\n  }\n\n  &:disabled {\n    background: #a0c3ff;\n    cursor: not-allowed;\n    opacity: 0.6;\n  }\n"])));
var CopiedText = styled.p(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: #34a853;\n  margin-top: 14px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  color: #34a853;\n  margin-top: 14px;\n"])));
var GoogleName = styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  font-weight: 500;\n  font-family: 'Google Sans', sans-serif;\n"], ["\n  font-weight: 500;\n  font-family: 'Google Sans', sans-serif;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
